export { CurrencyRatePageTemplate } from "./CurrencyRatePageTemplate";
